let pendingChainId: number | undefined;
let expiresAt = 0;

export const markPendingWalletChainSwitch = (chainId: number, ttlMs = 15000, now = Date.now()): void => {
    pendingChainId = chainId;
    expiresAt = now + ttlMs;
};

export const clearPendingWalletChainSwitch = (): void => {
    pendingChainId = undefined;
    expiresAt = 0;
};

export const shouldWaitForPendingWalletChainSwitch = (currentChainId: number, now = Date.now()): boolean => {
    if (pendingChainId === undefined) return false;
    if (now > expiresAt) {
        clearPendingWalletChainSwitch();
        return false;
    }
    return currentChainId !== pendingChainId;
};

export const isPendingWalletChainSwitchTarget = (currentChainId: number, now = Date.now()): boolean => {
    if (pendingChainId === undefined) return false;
    if (now > expiresAt) {
        clearPendingWalletChainSwitch();
        return false;
    }
    return currentChainId === pendingChainId;
};

